document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-sq-toggle]');
  if (toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.hidden = expanded;
  }
  if (event.target.closest('[data-sq-close]')) {
    const summary = document.querySelector('#Details-menu-drawer-container > summary');
    if (summary) summary.click();
  }
});


function configureSkinQuizFooter() {
  const desktop = window.matchMedia('(min-width: 990px)').matches;
  document.querySelectorAll('.sq-footer-details').forEach(details => { details.open = desktop; });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', configureSkinQuizFooter);
else configureSkinQuizFooter();
window.matchMedia('(min-width: 990px)').addEventListener('change', configureSkinQuizFooter);
document.addEventListener('shopify:section:load', configureSkinQuizFooter);
